<template>
  <div>

    <b-row class="mb-3">
      <b-col>
        <b-form-radio-group v-model="escalaTipo">
          <b-form-radio :value=1 >KPS</b-form-radio>
          <b-form-radio :value=2 >Ecog</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>


    <b-card v-if="escalaTipo == 1" border-variant="light">
      <b-row class="my-1 align-items-center">
        <b-col class="col-2">
          <label for="" class="mr-1">Escala KPS:</label>
        </b-col>

        <b-col class="col-8">
          <b-input-group :append="(escalaKps * 10).toString()">
            <b-form-input
              type="range"
              min="0"
              max="10"
              v-model="escalaKps"
            />
          </b-input-group>
          
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col>
          {{ messageKps }}
        </b-col>
      </b-row>
    </b-card>

    <b-card v-if="escalaTipo == 2" border-variant="light">
      <b-row class="my-1 align-items-center">
        <b-col class="col-2">
          <label for="" class="mr-1">Escala ecog:</label>
        </b-col>

        <b-col class="col-8">
          <b-input-group :append="escalaEcog.toString()">
            <b-form-input
              type="range"
              min=0
              max=5
              v-model="escalaEcog"
            />
          </b-input-group>      
        </b-col>

      </b-row>

      <b-row>
        <b-col>
          {{ messageEcog }}
        </b-col>
      </b-row>
    </b-card>

    
  </div>
</template>

<script>
export default {
  name: "OncologiaEscalas",

  data() {
    return {

      hasChangeKps: false,
      escalaTipo: 1,
      escalaKps: "10",
      escalaEcog: "0",

      messageKps:"",
      messageEcog:""
    }
  },


  watch: {

    escalaKps: {
      handler(newValue) {
        this.hasChangeKps = true;
        this.onEscalaKpsChange(newValue);
      },
    },

    escalaEcog: {
      handler(newValue) {
        this.hasChangeKps = false;
        this.onEscalaEcogChange(newValue);
      },
    }
  },


  methods: {
    onEscalaKpsChange(newValue) {
      
      if( !this.hasChangeKps ) return;

      const valueKps  = parseInt(newValue, 10);
      if( valueKps === 10 ) this.escalaEcog = 0;
      if( valueKps === 8 || valueKps === 9 ) this.escalaEcog = 1;
      if( valueKps === 6 || valueKps === 7 ) this.escalaEcog = 2;
      if( valueKps === 4 || valueKps === 5 ) this.escalaEcog = 3;
      if( valueKps === 1 || valueKps === 2 || valueKps === 3 ) this.escalaEcog = 4;
      if( valueKps === 0 ) this.escalaEcog = 5;
      this.onSetMessages();
    },

    onEscalaEcogChange(newValue){

      if( this.hasChangeKps ) return;

      const valueEcog = parseInt(newValue, 10);
      if( valueEcog === 0 ) this.escalaKps = 10;
      if( valueEcog === 1 ) this.escalaKps = 8;
      if( valueEcog === 2 ) this.escalaKps = 6;
      if( valueEcog === 3 ) this.escalaKps = 4;
      if( valueEcog === 4 ) this.escalaKps = 2;
      if( valueEcog === 5 ) this.escalaKps = 0;

      this.onSetMessages();
    },

    onSetMessages(){
      const kpsValue  = parseInt(this.escalaKps, 10);
      const ecogValue = parseInt(this.escalaEcog, 10);

      if( kpsValue === 10 ) 
        this.messageKps = "Normal, no hay molestias. No hay evidencia de enfermedad.";

      if( kpsValue === 9 )  
        this.messageKps = "Capaz de realizar actividad normal. Signos y síntomas menores de enfermedad.";

      if( kpsValue === 8 )  
        this.messageKps = "Actividad normal con esfuerzo. Algunos signos y síntomas de enfermedad.";      

      if( kpsValue === 7 )  
        this.messageKps = "Cuidado de sí mismo. Incapaz de realizar actividad normal o de realizar  trabajo activo.";      

      if( kpsValue === 6 )  
        this.messageKps = "Actividad normal con esfuerzo. Algunos signos y síntomas de enfermedad.";      

      if( kpsValue === 5 )
        this.messageKps = "Requiere asistencia considerable y cuidados médicos frecuentes"

      if( kpsValue === 4 )
        this.messageKps = "Discapacitado, requiere cuidados especiales y asistencia"

      if( kpsValue === 3 )
        this.messageKps = "Gravemente discapacitado. Hospitalización está indicada, aunque muerte no se ve inminente."

      if( kpsValue === 2 )
        this.messageKps = "Muy enfermo. Hospitalización es necesaria. Tratamientos de soporte activo son necesarios."

      if( kpsValue === 1 )
        this.messageKps = "Moribundo, proceso fatal progresando rápidamente"

      if( kpsValue === 0 )
        this.messageKps = "Muerte";

      //

      if( ecogValue === 0 )
        this.messageEcog = "Completamente activo, capaz de realizar todas las actividades previas a la enfermedad sin restricción..";

      if( ecogValue === 1 )
        this.messageEcog = "Restringido en actividad física extrema, capaz de caminar y realizar trabajos livianos, ejm, trabajo en casa liviano, trabajo de oficina.";

      if( ecogValue === 2 )
        this.messageEcog = "Capaz de caminar y autocuidado, pero incapaz de realizar cualquier tipo de trabajo. Deambula mas del 50% de las horas que esta despierto.";

      if( ecogValue === 3 )
        this.messageEcog = "Capaz   de autocuidado limitado, se mantiene postrado o en silla más del 50% de las horas que está despierto.";

      if( ecogValue === 4 )
        this.messageEcog = "Completamente incapacitado. No puede realizar autocuidado. Totalmente confinado en cama o silla.";

      if( ecogValue === 5 )
        this.messageEcog = "Muerte"

    }
  }

}
</script>
